<span class="icon-button"
      [class.selected]="selected"
      [class.light-rest]="variant === 'light-rest'"
      [class.danger-flat]="variant === 'danger-flat'"
      [style.--icon-button-rest-background]="restBackground">
  <ng-container *ngIf="hasActiveIcon; else singleIcon">
    <img class="icon-image icon-image-default"
         [src]="iconSrc"
         [alt]="label ? (label | translate) : icon">
    <img class="icon-image icon-image-active"
         [src]="activeIconSrc"
         [alt]="label ? (label | translate) : activeIcon">
  </ng-container>

  <ng-template #singleIcon>
    <img class="icon-image"
         [src]="iconSrc"
         [alt]="label ? (label | translate) : icon">
  </ng-template>
</span>

<label *ngIf="label"
       class="icon-label"
       [class.selected]="selected">
  {{ label | translate }}
</label>
